// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.build-campaign-div {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.build-campaign {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.07px;
  color: #101828;
}
.build-campaign-sub-text {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #6a7282;
}
.search-filters-details {
  /* width: 802.65625; */
  width: 100% !important;
  height: 60;
  gap: 12px;
  opacity: 1;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 12px;
  padding-left: 16px;
  border-radius: 16px;
  border-width: 1px;
  color: var(--Colors-Text-100, #ffffff);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100% !important;
  flex-wrap: wrap !important;
  /* align-items: center; */
}
.search-filters-details .ant-card-body {
  width: 100% !important;
  box-sizing: border-box;
  padding: 12px !important;
}
.search-filters-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.asset-search {
  border: 1px solid #e5e7eb !important;
}
.asset-search:hover {
  border: 1px solid #e5e7eb !important;
}
.allTypeButton {
  opacity: 1;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  border-radius: 10px;
  border-width: 1px;
  /* border: 1px solid var(--Colors-Primary-500, #d2042d); */
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: capitalize;
  background: #fff0f2;
  color: #6b7280;
}
.allTypeButton:hover {
  background: #fff0f2 !important;
  color: #6b7280 !important;
  border: 1px solid #e5e7eb !important;
}
.digitalButton {
  opacity: 1;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  border-radius: 10px;
  border-width: 1px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: capitalize;
  color: #6b7280;
}
.digitalButton:hover {
  background: #f9fafb !important;
  border: 1px solid #e5e7eb !important;
  color: #6b7280 !important;
}
.staticButton {
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  border-radius: 10px;
  border-width: 1px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: capitalize;
  color: #6b7280;
}
.staticButton:hover {
  background: #f9fafb !important;
  border: 1px solid #e5e7eb !important;
  color: #6b7280 !important;
}
.filterIcon {
  height: 14px;
  width: 14px;
}
.default-order-select {
  width: 140px !important;
  min-width: 140px !important;
  flex-shrink: 0;
  border-radius: 10px;
  border-width: 1px;
  border: 2px solid #e5e7eb;
}
.search-filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100% !important;
  gap: 12px;
}
.search-details-section {
  width: 100% !important;
}

.search-details-section .ant-card-body {
  width: 100% !important;
  box-sizing: border-box;
  border: 1px solid #e5e7eb;
}
.asset-search {
  width: 100% !important;
}
.cart-details-card {
  width: 100% !important;
  max-width: 100% !important;
}
.cart-details-section-inner-div {
  display: flex;
  gap: 24px;
}
cart-details-section-inner-div:first div {
  width: 100% !important;
}
.ant-select-dropdown.default-order-dropdown .ant-select-item-option-content {
  font-size: 12px !important;
}

.type-buttons {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}
.digital-contnet-inner {
  display: flex;
  gap: 2px;
  align-items: center;
}
.copy-icon {
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.digital-contnet-inner:hover .copy-icon {
  opacity: 1;
  visibility: visible;
}
.cart-summary-header {
  opacity: 1;
  padding-top: 16px;
  padding-right: 20px;
  padding-bottom: 16px;
  padding-left: 20px;
  border: 1px;
  background: linear-gradient(360deg, #fff0f2 0%, #ffffff 100%);
  border-bottom: 1px solid #f9fafb;
  border-radius: 16px 16px 0px 0px;
}
.proceed-to-check-out-col {
  border-radius: 16px;
  border-width: 1px;
}
.cart-summary-txt {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 27px;
  letter-spacing: -0.44px;
}
.cart-summary-assets {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
}
.cart-summary-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.campaign-name {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
}
.campaign-row {
  gap: 8px;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
}

.campaign-assets {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
}
.campaign-details {
  display: flex;
  flex-direction: column;
}
.proceed-to-check-out-col .ant-card .ant-card-body {
  padding: 0px !important;
}
.proceed-to-check-out-col {
  width: 25px !important;
}
.cart-summary-content {
  max-height: 400px;
  overflow-y: auto;
  padding-top: 16px;
  padding-right: 20px;
  padding-bottom: 16px;
  padding-left: 20px;
}
.campaign-price {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #101828;
}
.subtotal-row {
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
}
.subtotal-text {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
}
.subtotal-price {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #101828;
}
.summary-row-taxes-row {
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
}
.subtotal-text {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}
.subtotal-siginig {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}
.estimated-total {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: -0.31px;
  color: #101828;
}
.estimated-total-price {
  font-family: Roboto !important;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: -0.45px;
  color: var(--Colors-Primary-500, #d2042d);
}
.estimated-total-row {
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
}
.review-sign-button {
  width: 100%;
  height: 48px;
  padding-top: 12px;
  padding-bottom: 12px;
  background: var(--Background, #d2042d);
  border-radius: 14px;
  border-width: 1px;
}
.review-sign-button-text {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: -0.31px;
  text-align: center;
  color: var(--Colors-Text-100, #ffffff);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.cart-summary-buttons {
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
.continue-shopping-button {
  width: 100%;
  height: 42px;
  border-radius: 14px;
  border-width: 1px;
  border-top: 1px solid #e5e7eb;
}
.continue-shopping-button:hover,
.continue-shopping-button:focus,
.Ai-review-sign,
.continue-shopping-button:active {
  background: #ffffff !important;
  border-color: #e5e7eb !important;
  color: inherit !important;
}
.cart-benefits {
  padding-top: 4px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  border-top-width: 1px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: flex-start;
}
.cart-benefits-text {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
  display: flex;
  gap: 8px;
}
.cart-divider {
  border-top: 1px solid #e2e5e9;
  margin: 12px 0;
}
.brand-awareness-col {
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  width: 100% !important;
  border-bottom: 1px solid #e5e7eb;
}
.brandAwareness {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #1e2939;
  padding-left: 4px;
}
.brandAwareness-total {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0.37px;
  text-align: right;
  text-transform: uppercase;
  color: #99a1af;
}
.brand-awareness-col {
  background-color: #f5f6f8;
  padding: 16px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 12px 12px 0px 0px;
}
.allTypeButton.selected,
.digitalButton.selected,
.staticButton.selected {
  border: 1px solid #d2042d !important;
  color: #d2042d !important;
}
.digital-cardcampaign-row:hover {
  background-color: #f5f6f8 !important;
}

.check-box-campaigns-card .ant-card-body {
  padding: 0px !important;
  border: 1px solid #e5e7eb;
}
.brand-awareness {
  display: flex;
  /* gap: 10px; */
  justify-content: space-between;
  width: 100% !important;
}
.brandAwernessCol {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100% !important;
}
.brandAwareness-assets {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}
.brandAwareness-price {
  font-family: Roboto !important;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  text-align: right;
  color: #101828;
}
.brandAwareness-assets {
  display: flex;
  justify-content: space-between;
}
.digital-image {
  width: 64px;
  height: 64px;
  /* border-radius: 10px; */
}
.digital-cardcampaign-row {
  padding-top: 16px;
  padding-right: 20px;
  padding-bottom: 16px;
  padding-left: 40px;
  border-bottom-width: 1px;
}
.card-titles {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #101828;
}
.bill-board-price {
  font-family: Roboto !important;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: #101828;
}
.digital-cardcampaign-row {
  display: flex !important;
  align-items: flex-start;
  width: 100% !important;
  flex: 1 1;
  gap: 8px;
}

.digital-image {
  width: 70px;
  height: 70px;
  object-fit: cover;
  flex-shrink: 0;
}

.digital-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.card-titles {
  display: block;
}

.bill-board-price {
  display: block;
  white-space: nowrap;
  margin-left: 20px;
}
.digital-cardcampaign-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.digital-content {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  flex: 1 1;
}

.digital-details {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}
.digital-details-location {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}
.digital-location-div {
  display: flex;
  align-items: center;
  gap: 4px;
}
.asset-code {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}

.digital-type {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0.12px;
  color: #155dfc;
  background: #eff6ff;
  width: 44px;
  height: 19px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 6px;
  padding-bottom: 2px;
  padding-left: 6px;
  border: none;
}

.separator {
  color: #c0c4cc;
}

.campaign-price {
  margin-left: auto;
}
/* 
.bill-board-price {
  font-size: 14px;
  font-weight: 600;
} */
.location-image {
  width: 12px;
  height: 12px;
}
.location-text {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}
.date-css {
  font-family: Roboto !important;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  color: #99a1af;
}
.Ai-review-sign-col {
  width: 100% !important;
  padding-top: 12px;
  padding-right: 20px;
  padding-bottom: 12px;
  padding-left: 20px;
  border-top-width: 1px;
}
.Ai-review-sign-text {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: #6a7282;
}
.Ai-review-sign-div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.Ai-review-sign-div .Ai-review-sign:last-child {
  margin-left: auto !important;
}
.reviw-sign-button {
  gap: 6px;
  border-radius: 10px;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  background: var(--Background, #d2042d) !important;
}
.reviw-sign-button:hover,
.reviw-sign-button:focus,
.review-sign-button,
.reviw-sign-button:active {
  background: var(--Background, #d2042d) !important;
  color: #ffffff !important;
}

.review-sign-text {
  font-family: Roboto !important;
  font-weight: 600;
  font-style: Semibold;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: var(--Colors-Text-100, #ffffff);
}
.proceed-to-check-out-col {
  width: 25px !important;
}
.digital-location-move-delete-mobile {
  display: none;
}
.asset-row {
  border-bottom: 1px solid #e5e7eb;
}
.default-order-dropdown.ant-select-dropdown {
  padding: 0 !important;
}

.default-order-dropdown
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: rgba(189, 189, 189) !important;
}
.dashed_button {
  width: 100%;
  background: none;
  border: 2px solid #d1d5db;
  height: 48px;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 12px;
  padding-left: 16px;
  gap: 8px;
  border-radius: 16px;
  border-width: 2px;
}
.dashed_button:hover,
.dashed_button:focus,
.dashed_button:active {
  border: 2px dashed #d1d5db !important;
  box-shadow: none !important;
  outline: none !important;
}
.create_campaign_text_dashed_button_text {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  text-align: center;
  color: #9ca3af;
}
@media (max-width: 1024px) {
  .digital-details-location {
    width: 100% !important;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .digital-location-div {
    width: 43% !important;
  }
}

@media (max-width: 768px) {
  .cart-details-section-inner-div > .proceed-to-check-out-col {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    flex: 0 0 100% !important;
    margin-top: 14px !important;
  }
  .digital-cardcampaign-row {
    display: flex !important;
    align-items: flex-start;
    width: 100% !important;
    gap: 8px;
    flex-direction: column;
  }
  .bill-board-price {
    margin: 0px;
  }
  .cart-details-section-inner-div {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 24px !important;
    width: 100% !important;
  }
  .digital-content {
    margin-left: 0px;
  }
}

@media (max-width: 425px) {
  .digital-location-div {
    width: 100% !important;
  }
  .search-filters {
    display: flex;
    flex-wrap: wrap;
  }
  .type-buttons {
    display: flex;
    flex-wrap: wrap;
  }
  .digital-location-mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-top: 4px;
  }
  .digital-location-mobile-second-div {
    display: none;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .digital-location-move-delete-mobile {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
    padding-right: 20px;
    padding-left: 40px;
  }
  .digital-location-div-mobile {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .cart-summary-txt {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/cartCampaigns.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0DAA0D;EAC1D,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,6DAA6D;EAC7D,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;GAIG;AACH;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;AACA;;;;EAIE,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;;EAGE,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".build-campaign-div {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.build-campaign {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 24px;\n  line-height: 36px;\n  letter-spacing: 0.07px;\n  color: #101828;\n}\n.build-campaign-sub-text {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #6a7282;\n}\n.search-filters-details {\n  /* width: 802.65625; */\n  width: 100% !important;\n  height: 60;\n  gap: 12px;\n  opacity: 1;\n  padding-top: 12px;\n  padding-right: 16px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  border-radius: 16px;\n  border-width: 1px;\n  color: var(--Colors-Text-100, #ffffff);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100% !important;\n  flex-wrap: wrap !important;\n  /* align-items: center; */\n}\n.search-filters-details .ant-card-body {\n  width: 100% !important;\n  box-sizing: border-box;\n  padding: 12px !important;\n}\n.search-filters-div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.asset-search {\n  border: 1px solid #e5e7eb !important;\n}\n.asset-search:hover {\n  border: 1px solid #e5e7eb !important;\n}\n.allTypeButton {\n  opacity: 1;\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  border-radius: 10px;\n  border-width: 1px;\n  /* border: 1px solid var(--Colors-Primary-500, #d2042d); */\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  text-transform: capitalize;\n  background: #fff0f2;\n  color: #6b7280;\n}\n.allTypeButton:hover {\n  background: #fff0f2 !important;\n  color: #6b7280 !important;\n  border: 1px solid #e5e7eb !important;\n}\n.digitalButton {\n  opacity: 1;\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  border-radius: 10px;\n  border-width: 1px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  text-transform: capitalize;\n  color: #6b7280;\n}\n.digitalButton:hover {\n  background: #f9fafb !important;\n  border: 1px solid #e5e7eb !important;\n  color: #6b7280 !important;\n}\n.staticButton {\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  border-radius: 10px;\n  border-width: 1px;\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  text-transform: capitalize;\n  color: #6b7280;\n}\n.staticButton:hover {\n  background: #f9fafb !important;\n  border: 1px solid #e5e7eb !important;\n  color: #6b7280 !important;\n}\n.filterIcon {\n  height: 14px;\n  width: 14px;\n}\n.default-order-select {\n  width: 140px !important;\n  min-width: 140px !important;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border-width: 1px;\n  border: 2px solid #e5e7eb;\n}\n.search-filters {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100% !important;\n  gap: 12px;\n}\n.search-details-section {\n  width: 100% !important;\n}\n\n.search-details-section .ant-card-body {\n  width: 100% !important;\n  box-sizing: border-box;\n  border: 1px solid #e5e7eb;\n}\n.asset-search {\n  width: 100% !important;\n}\n.cart-details-card {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n.cart-details-section-inner-div {\n  display: flex;\n  gap: 24px;\n}\ncart-details-section-inner-div:first div {\n  width: 100% !important;\n}\n.ant-select-dropdown.default-order-dropdown .ant-select-item-option-content {\n  font-size: 12px !important;\n}\n\n.type-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n}\n.digital-contnet-inner {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n.copy-icon {\n  opacity: 0;\n  visibility: hidden;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.digital-contnet-inner:hover .copy-icon {\n  opacity: 1;\n  visibility: visible;\n}\n.cart-summary-header {\n  opacity: 1;\n  padding-top: 16px;\n  padding-right: 20px;\n  padding-bottom: 16px;\n  padding-left: 20px;\n  border: 1px;\n  background: linear-gradient(360deg, #fff0f2 0%, #ffffff 100%);\n  border-bottom: 1px solid #f9fafb;\n  border-radius: 16px 16px 0px 0px;\n}\n.proceed-to-check-out-col {\n  border-radius: 16px;\n  border-width: 1px;\n}\n.cart-summary-txt {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 18px;\n  leading-trim: NONE;\n  line-height: 27px;\n  letter-spacing: -0.44px;\n}\n.cart-summary-assets {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n}\n.cart-summary-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.campaign-name {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n}\n.campaign-row {\n  gap: 8px;\n  opacity: 1;\n  display: flex;\n  justify-content: space-between;\n  padding-top: 12px;\n}\n\n.campaign-assets {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n}\n.campaign-details {\n  display: flex;\n  flex-direction: column;\n}\n.proceed-to-check-out-col .ant-card .ant-card-body {\n  padding: 0px !important;\n}\n.proceed-to-check-out-col {\n  width: 25px !important;\n}\n.cart-summary-content {\n  max-height: 400px;\n  overflow-y: auto;\n  padding-top: 16px;\n  padding-right: 20px;\n  padding-bottom: 16px;\n  padding-left: 20px;\n}\n.campaign-price {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #101828;\n}\n.subtotal-row {\n  padding-top: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n.subtotal-text {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n}\n.subtotal-price {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #101828;\n}\n.summary-row-taxes-row {\n  padding-top: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n.subtotal-text {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n.subtotal-siginig {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n.estimated-total {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 24px;\n  letter-spacing: -0.31px;\n  color: #101828;\n}\n.estimated-total-price {\n  font-family: Roboto !important;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  leading-trim: NONE;\n  line-height: 28px;\n  letter-spacing: -0.45px;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.estimated-total-row {\n  padding-top: 12px;\n  display: flex;\n  justify-content: space-between;\n}\n.review-sign-button {\n  width: 100%;\n  height: 48px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  background: var(--Background, #d2042d);\n  border-radius: 14px;\n  border-width: 1px;\n}\n.review-sign-button-text {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 24px;\n  letter-spacing: -0.31px;\n  text-align: center;\n  color: var(--Colors-Text-100, #ffffff);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.cart-summary-buttons {\n  padding-right: 20px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n}\n.continue-shopping-button {\n  width: 100%;\n  height: 42px;\n  border-radius: 14px;\n  border-width: 1px;\n  border-top: 1px solid #e5e7eb;\n}\n.continue-shopping-button:hover,\n.continue-shopping-button:focus,\n.Ai-review-sign,\n.continue-shopping-button:active {\n  background: #ffffff !important;\n  border-color: #e5e7eb !important;\n  color: inherit !important;\n}\n.cart-benefits {\n  padding-top: 4px;\n  padding-right: 20px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n  border-top-width: 1px;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.cart-benefits-text {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n  display: flex;\n  gap: 8px;\n}\n.cart-divider {\n  border-top: 1px solid #e2e5e9;\n  margin: 12px 0;\n}\n.brand-awareness-col {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: center;\n  width: 100% !important;\n  border-bottom: 1px solid #e5e7eb;\n}\n.brandAwareness {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #1e2939;\n  padding-left: 4px;\n}\n.brandAwareness-total {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 10px;\n  leading-trim: NONE;\n  line-height: 15px;\n  letter-spacing: 0.37px;\n  text-align: right;\n  text-transform: uppercase;\n  color: #99a1af;\n}\n.brand-awareness-col {\n  background-color: #f5f6f8;\n  padding: 16px 20px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px 12px 0px 0px;\n}\n.allTypeButton.selected,\n.digitalButton.selected,\n.staticButton.selected {\n  border: 1px solid #d2042d !important;\n  color: #d2042d !important;\n}\n.digital-cardcampaign-row:hover {\n  background-color: #f5f6f8 !important;\n}\n\n.check-box-campaigns-card .ant-card-body {\n  padding: 0px !important;\n  border: 1px solid #e5e7eb;\n}\n.brand-awareness {\n  display: flex;\n  /* gap: 10px; */\n  justify-content: space-between;\n  width: 100% !important;\n}\n.brandAwernessCol {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100% !important;\n}\n.brandAwareness-assets {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n.brandAwareness-price {\n  font-family: Roboto !important;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  text-align: right;\n  color: #101828;\n}\n.brandAwareness-assets {\n  display: flex;\n  justify-content: space-between;\n}\n.digital-image {\n  width: 64px;\n  height: 64px;\n  /* border-radius: 10px; */\n}\n.digital-cardcampaign-row {\n  padding-top: 16px;\n  padding-right: 20px;\n  padding-bottom: 16px;\n  padding-left: 40px;\n  border-bottom-width: 1px;\n}\n.card-titles {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #101828;\n}\n.bill-board-price {\n  font-family: Roboto !important;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  color: #101828;\n}\n.digital-cardcampaign-row {\n  display: flex !important;\n  align-items: flex-start;\n  width: 100% !important;\n  flex: 1;\n  gap: 8px;\n}\n\n.digital-image {\n  width: 70px;\n  height: 70px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.digital-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.card-titles {\n  display: block;\n}\n\n.bill-board-price {\n  display: block;\n  white-space: nowrap;\n  margin-left: 20px;\n}\n.digital-cardcampaign-row {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.digital-content {\n  display: flex;\n  flex-direction: column;\n  margin-left: 12px;\n  flex: 1;\n}\n\n.digital-details {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 4px;\n}\n.digital-details-location {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 4px;\n}\n.digital-location-div {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.asset-code {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n\n.digital-type {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 10px;\n  leading-trim: NONE;\n  line-height: 15px;\n  letter-spacing: 0.12px;\n  color: #155dfc;\n  background: #eff6ff;\n  width: 44px;\n  height: 19px;\n  angle: 0 deg;\n  opacity: 1;\n  border-radius: 4px;\n  padding-top: 2px;\n  padding-right: 6px;\n  padding-bottom: 2px;\n  padding-left: 6px;\n  border: none;\n}\n\n.separator {\n  color: #c0c4cc;\n}\n\n.campaign-price {\n  margin-left: auto;\n}\n/* \n.bill-board-price {\n  font-size: 14px;\n  font-weight: 600;\n} */\n.location-image {\n  width: 12px;\n  height: 12px;\n}\n.location-text {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n.date-css {\n  font-family: Roboto !important;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  color: #99a1af;\n}\n.Ai-review-sign-col {\n  width: 100% !important;\n  padding-top: 12px;\n  padding-right: 20px;\n  padding-bottom: 12px;\n  padding-left: 20px;\n  border-top-width: 1px;\n}\n.Ai-review-sign-text {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #6a7282;\n}\n.Ai-review-sign-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.Ai-review-sign-div .Ai-review-sign:last-child {\n  margin-left: auto !important;\n}\n.reviw-sign-button {\n  gap: 6px;\n  border-radius: 10px;\n  padding-top: 8px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  background: var(--Background, #d2042d) !important;\n}\n.reviw-sign-button:hover,\n.reviw-sign-button:focus,\n.review-sign-button,\n.reviw-sign-button:active {\n  background: var(--Background, #d2042d) !important;\n  color: #ffffff !important;\n}\n\n.review-sign-text {\n  font-family: Roboto !important;\n  font-weight: 600;\n  font-style: Semibold;\n  font-size: 12px;\n  leading-trim: NONE;\n  line-height: 16px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: var(--Colors-Text-100, #ffffff);\n}\n.proceed-to-check-out-col {\n  width: 25px !important;\n}\n.digital-location-move-delete-mobile {\n  display: none;\n}\n.asset-row {\n  border-bottom: 1px solid #e5e7eb;\n}\n.default-order-dropdown.ant-select-dropdown {\n  padding: 0 !important;\n}\n\n.default-order-dropdown\n  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: rgba(189, 189, 189) !important;\n}\n.dashed_button {\n  width: 100%;\n  background: none;\n  border: 2px solid #d1d5db;\n  height: 48px;\n  padding-top: 12px;\n  padding-right: 16px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  gap: 8px;\n  border-radius: 16px;\n  border-width: 2px;\n}\n.dashed_button:hover,\n.dashed_button:focus,\n.dashed_button:active {\n  border: 2px dashed #d1d5db !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.create_campaign_text_dashed_button_text {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  text-align: center;\n  color: #9ca3af;\n}\n@media (max-width: 1024px) {\n  .digital-details-location {\n    width: 100% !important;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  .digital-location-div {\n    width: 43% !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .cart-details-section-inner-div > .proceed-to-check-out-col {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 100% !important;\n    flex: 0 0 100% !important;\n    margin-top: 14px !important;\n  }\n  .digital-cardcampaign-row {\n    display: flex !important;\n    align-items: flex-start;\n    width: 100% !important;\n    gap: 8px;\n    flex-direction: column;\n  }\n  .bill-board-price {\n    margin: 0px;\n  }\n  .cart-details-section-inner-div {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr) !important;\n    gap: 24px !important;\n    width: 100% !important;\n  }\n  .digital-content {\n    margin-left: 0px;\n  }\n}\n\n@media (max-width: 425px) {\n  .digital-location-div {\n    width: 100% !important;\n  }\n  .search-filters {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .type-buttons {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .digital-location-mobile {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    margin-top: 4px;\n  }\n  .digital-location-mobile-second-div {\n    display: none;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .digital-location-move-delete-mobile {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    width: 100%;\n    padding-right: 20px;\n    padding-left: 40px;\n  }\n  .digital-location-div-mobile {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n  .cart-summary-txt {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
